import moment from 'moment';
import 'moment/locale/de';
import Vue from 'vue';
import VueMoment from 'vue-moment';

moment.locale('de');

Vue.use(VueMoment, {
    moment
});
